var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVotingIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\x8E\xD0\xA0\xC2\xBB\xD0\xA0\xD1\x95\xD0\xA0\xE2\x84\x96_1",
    clipPath: "url(#clip0_3_94231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0H4C1.79086 0 0 1.79086 0 4V30C0 32.2091 1.79086 34 4 34H30C32.2091 34 34 32.2091 34 30V4C34 1.79086 32.2091 0 30 0Z",
    fill: "#E8E8F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.05 25.7701H8.48999V19.8101",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.68 8.29004H25.97V14.04",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.48 17.0298H21.34V27.0698H27.48V17.0298Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.69 17.8298V16.0498C6.69 15.1098 7.46 14.3398 8.4 14.3398H13.2C14.14 14.3398 14.91 15.1098 14.91 16.0498V17.8298",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.26 9.39993C13.26 10.7599 12.16 11.8699 10.79 11.8699C9.42001 11.8699 8.32001 10.7699 8.32001 9.39993C8.32001 8.02993 9.42001 6.92993 10.79 6.92993C12.16 6.92993 13.26 8.02993 13.26 9.39993Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_94231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotingIcon2);
export default __webpack_public_path__ + "static/media/voting_icon2.a1afc1519ddb2395e12d19ce6e0e3bd3.svg";
export { ForwardRef as ReactComponent };